export const isRtlLanguage = (lang: string) => {
  return ['ar', 'he', 'fa', 'ur'].includes(lang)
}
